module.exports = __webpack_public_path__ + "img/visore_2025.242ad1a8.png";